import Swiper from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

export default (options = {}) => ({
    swiper: null,
  
    init() {
      const defaults = {
        slidesPerView: 'auto',
        spaceBetween: 24,
        grabCursor: true,
        freeMode: true,
        loop: false,
        watchOverflow: true,
      };
  
      this.swiper = new Swiper(this.$refs.swiper, {
        ...defaults,
        ...options,
      });
    },
  
    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
  });